export default __webpack_public_path__ + "static/media/accelerating-btn.7a982ca2.svg";